export const SET_USERS = 'SET_USERS'
export const USER_CONNECTION = 'USER_CONNECTION'
export const USER_DISCONNECTION = 'USER_DISCONNECTION'
export const USER_UPDATE_OR_ADD = 'USER_UPDATE_OR_ADD'
export const USER_STATE_CHANGE = 'USER_STATE_CHANGE'
export const RESET_STATE = 'RESET_STATE'
